import { render, staticRenderFns } from "./CustomersComp.vue?vue&type=template&id=9c31d180&scoped=true&"
import script from "./CustomersComp.vue?vue&type=script&lang=js&"
export * from "./CustomersComp.vue?vue&type=script&lang=js&"
import style0 from "./CustomersComp.vue?vue&type=style&index=0&id=9c31d180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c31d180",
  null
  
)

export default component.exports